import * as Sentry from '@sentry/react-native';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { isRunningInExpoGo } from 'expo';
import { Stack, useNavigationContainerRef } from 'expo-router';
import { useEffect } from 'react';
import 'react-native-get-random-values';
import '../global.css';

const navigationIntegration = Sentry.reactNavigationIntegration({
  enableTimeToInitialDisplay: !isRunningInExpoGo(),
});

Sentry.init({
  dsn: 'https://56729ce3032e0d97e3a0903860d797d5@o4508558394195968.ingest.de.sentry.io/4508558397800528',
  tracesSampleRate: 1.0,
  profilesSampleRate: 1.0,
  debug: false,
  integrations: [
    // Pass integration
    Sentry.mobileReplayIntegration(),
    navigationIntegration,
  ],
  enableNativeFramesTracking: !isRunningInExpoGo(),
  enableNativeCrashHandling: !isRunningInExpoGo(),
  enableAutoSessionTracking: true,
  enableAutoPerformanceTracing: true,
  enableNativeNagger: !isRunningInExpoGo(),
  enableNative: true,
  environment: 'development',
});

const queryClient = new QueryClient();

function RootLayout() {
  const ref = useNavigationContainerRef();

  useEffect(() => {
    if (ref?.current) {
      navigationIntegration.registerNavigationContainer(ref);
    }
  }, [ref]);
  return (
    <QueryClientProvider client={queryClient}>
      <Stack>
        <Stack.Screen name="index" options={{ headerShown: false }} />
        <Stack.Screen name="(auth)" options={{ headerShown: false }} />
        <Stack.Screen name="(root)" options={{ headerShown: false }} />
      </Stack>
    </QueryClientProvider>
  );
}

export default Sentry.wrap(RootLayout);
